import dayjs from "dayjs";

const MESES = [
  "enero", "febrero", "marzo", "abril", "mayo", "junio",
  "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
];

export const objetivoPorDefecto = (proyecto) =>
  `Suministro de herramientas, equipos, insumos e infraestructura a los y las participantes del proyecto denominado "${proyecto || ""}".`;

const numero = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? String(n) : (v ?? "");
};

// Arma los datos del PDF a partir de:
//  acta:   datos del encabezado de la entrega (fila agrupada del listado o lo
//          que se acaba de guardar en el formulario)
//  lineas: productos entregados
//  extras: vereda y objetivo digitados en el momento; si no vienen se usan los
//          que el acta tiene guardados
export const construirDatosActa = (acta, lineas, extras = {}) => {
  // Se toma solo la parte de fecha para que la zona horaria no corra el día.
  const fecha = dayjs(String(acta.fecha_entrega).slice(0, 10));
  const esOrganizacion = Number(acta.tipo_entrega) === 2;

  return {
    esOrganizacion,
    nombreProyecto: acta.proyecto || "",
    tipoActa: acta.tipo_acta || "Parcial",
    fechaEntrega: fecha.isValid() ? fecha.format("DD/MM/YYYY") : "",
    fechaDia: fecha.isValid() ? fecha.format("DD") : "____",
    fechaMes: fecha.isValid() ? MESES[fecha.month()] : "________",
    fechaAnio: fecha.isValid() ? fecha.format("YYYY") : "____",
    departamento: acta.departamento || "",
    municipio: acta.municipio || "",
    vereda: (extras.vereda || acta.vereda || "").trim(),
    lugarEntrega: acta.lugar_entrega || "",
    telefono: acta.telefono_contacto_entrega || "",
    objetivo: (extras.objetivo || acta.objetivo || "").trim() || objetivoPorDefecto(acta.proyecto),
    usuarioEntrega: acta.usuario_entrega_nombre || "",
    usuarioSupervisor: acta.usuario_supervisor_nombre || "",
    nombreBeneficiario: acta.nombre_entrega || "",
    identificacion: acta.identificacion || "",
    razonSocial: acta.nombre_entrega || "",
    sigla: acta.sigla || "",
    nit: acta.identificacion || "",
    representanteLegalNombre: acta.representante_legal_nombre || "",
    representanteLegalCedula: acta.representante_legal_cedula || "",
    bienes: (lineas || []).map((l) => ({
      bien: l.nombre_corto || l.nombre_producto || "",
      cantidad: numero(l.cantidad),
      descripcion: l.descripcion || l.nombre_producto || "",
      observaciones: l.unidad_medida || ""
    }))
  };
};

export const nombreArchivoActa = (acta) => {
  const fecha = dayjs(String(acta.fecha_entrega).slice(0, 10));
  const tipo = Number(acta.tipo_entrega) === 2 ? "N" : "C";
  const id = String(acta.identificacion || acta.oid_participante || "").replace(/[^A-Za-z0-9-]/g, "");
  return `${fecha.isValid() ? fecha.format("DDMMYYYY") : "acta"}_Acta_entrega_${tipo}${id}.pdf`;
};
